import React from 'react';
import { Box, Typography, Container, Paper, Divider, Link } from '@mui/material';

const NewPrivacy = () => {
  const handleTermsClick = () => {
    window.open('/terms', '_blank');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'rgba(228, 228, 228, 0.6)',
        py: 4
      }}
    >
      <Container maxWidth="lg">
        <Paper elevation={2} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h3" component="h1" sx={{ mb: 3, textAlign: 'center', fontWeight: 600, color: 'primary.main'}}>
            PageSmooth 隐私保护协议
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
            生效日期：2025年6月20日 | 最后更新时间：2025年6月20日
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            郑州译悦翻译有限公司就PageSmooth签证翻译服务平台的使用采取本隐私保护协议。本协议与
            <Link
              onClick={handleTermsClick}
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              《PageSmooth用户服务协议》
            </Link>
            共同构成您使用我们服务的完整法律框架。
          </Typography>
          
          <Divider sx={{ mb: 4 }} />
          
          <Box sx={{ '& > *': { mb: 4 } }}>
            {/* 欢迎使用PageSmooth */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                欢迎使用PageSmooth！
              </Typography>
              
              <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                感谢您选择PageSmooth签证翻译服务！我们深知个人信息对您的重要性，并会全力保护您的个人信息安全可靠。我们承诺严格遵守相关法律法规，遵循正当、合法、必要的原则，处理您的个人信息。
              </Typography>
              
              <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                本隐私保护协议（以下简称"<strong>本协议</strong>"）将详细说明我们在您使用PageSmooth服务过程中如何收集、使用、存储、共享、转让和保护您的个人信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
              </Typography>
              
              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                请您仔细阅读本协议。如果您不同意本协议的任何内容，请您停止使用我们的服务。您使用我们的服务，即表示您已阅读并同意我们按照本协议处理您的相关信息。
              </Typography>
            </Box>

            {/* 第一章 我们收集的个人信息 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第一章 我们收集的个人信息
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>1.1 信息收集原则</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们遵循最小必要原则，仅收集为您提供服务所必需的个人信息，不会收集与服务无关的个人信息。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>1.2 我们收集的信息类型</Typography>
                
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>（一）您主动提供的信息</Typography>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>1. 账户登录与注册</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）用户名</strong>：您在首次登录时，系统会根据规则为您自动注册一个账号，并自动生成5-12位唯一的数字和字母组合的用户名，作为唯一标识，同时用户可以主动修改。我们收集此信息用于账户识别、登录验证、个性化服务展示，这是必需信息，数据类型为字符串（长度5-12位），在账户存续期间保存。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）密码</strong>：您设置的账户登录密码，用于账户安全验证、防止未经授权的访问。这是密码登录方式的必需信息，采用加密算法进行不可逆加密存储，在账户存续期间保存。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）手机号码</strong>：您提供的手机号码（11位中国大陆手机号），用于身份验证、短信验证码发送、安全提醒、客服联系。此信息为可选（但某些功能需要），主要用于手机验证码登录、安全验证、重要通知等场景，在账户存续期间保存。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（4）手机号验证码登录</strong>：包括手机号码（用于接收验证码的手机号，用于身份验证、发送短信验证码，采用6位数字验证码，有效期5分钟，安全措施包括限制发送频率：1分钟1次，1小时最多3次）和验证码（系统生成的6位数字验证码，用于验证手机号归属、防止恶意注册，验证成功后立即删除，采用加密传输、服务端验证）。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（5）第三方登录</strong>：当您使用微信登录时，将采集包括微信OpenID（微信平台分配的用户唯一标识，用于关联微信账户、实现快速登录，数据来源于微信开放平台授权接口，选择微信登录时必需）、微信昵称（您在微信设置的昵称，用于个性化显示、改善用户体验），微信头像（您在微信设置的头像图片，用于个性化显示、改善用户体验）等信息。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mt: 2 }}>
                    通过账号密码、手机号、第三方登录等多种方式支持用户自行选择和使用，并确保用户在不同的客户端，不同设备上都能够自主登录使用，并确保个人信息的安全访问。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>2. 翻译服务信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）上传的文档内容</strong>：您上传的需要翻译的文档文件，用于提供翻译服务、格式识别、内容解析。这是必需信息，支持PDF、JPG、PNG、DOCX、DOC等格式，单文件最大100MB，翻译完成后7天内删除，采用加密算法加密存储、访问权限控制等安全措施。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）选择的翻译语言</strong>：源语言和目标语言选择，用于确定翻译方向、匹配翻译引擎、质量控制。这是必需信息，数据类型为语言代码（如zh-CN, en-US），与翻译记录一同保存。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）翻译需求说明</strong>：您对翻译的特殊要求或说明，用于在一对一服务中，提供个性化翻译服务、提高翻译质量。此信息为可选，数据类型为文本（最多500字符），与翻译记录一同保存。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（4）特殊要求备注</strong>：对翻译格式、术语等的特殊要求，用于满足个性化需求、确保翻译准确性。此信息为可选，与翻译记录一同保存。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>3. 认证服务信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（1）认证类型需求</strong>：所需的认证类型（如普通翻译认证、NAATI认证），用于提供相应的认证服务、匹配认证机构。认证服务时必需。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>4. 支付信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）支付方式选择</strong>：您选择的支付方式（微信支付、支付宝、银行卡），用于处理支付、生成订单、财务记录。购买服务时必需。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）交易金额</strong>：交易的具体金额（精确到分的金额数值），用于订单处理、财务记录、发票开具。保存3年（财务合规要求）。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）支付时间</strong>：支付完成的时间戳（ISO 8601标准时间格式），用于订单状态跟踪、财务对账、争议处理。保存3年。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（4）订单编号</strong>：系统生成的唯一订单标识（时间戳+随机数，确保唯一性），用于订单跟踪、客服支持、财务对账。保存3年。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>5. 客服沟通信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）咨询内容</strong>：您向客服咨询的具体内容（文本、图片、文件），用于提供客服支持、问题解决、服务改进。保存1年。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）反馈意见</strong>：您对服务的反馈和建议，用于服务质量改进、产品优化。此信息为可选，保存2年。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）投诉建议</strong>：您的投诉内容和改进建议，用于问题处理、服务改进、合规管理。处理流程为24小时内响应，7个工作日内处理，保存3年。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（4）通话录音</strong>：电话客服的通话录音，用于质量监控、争议处理、培训改进。通话开始前会明确告知录音，保存6个月，仅授权客服管理人员可访问。
                  </Typography>
                </Box>
                
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>（二）我们自动收集的信息</Typography>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>1. 设备信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）设备型号</strong>：您使用的设备型号标识（如iPhone 14 Pro、Samsung Galaxy S23），通过浏览器User-Agent、设备API收集，用于兼容性优化、问题诊断、统计分析。此信息不敏感。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）操作系统版本</strong>：设备操作系统及版本号（如iOS 16.1、Android 13、Windows 11），通过系统API、浏览器信息收集，用于功能兼容性、安全更新、性能优化，确保服务正常运行、提供最佳体验。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）浏览器类型和版本</strong>：您使用的浏览器信息（如Chrome 108.0、Safari 16.1、Firefox 107.0），通过HTTP请求头User-Agent收集，用于页面兼容性、功能支持、安全防护，优化页面显示、确保功能正常。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（4）屏幕分辨率</strong>：设备屏幕的分辨率信息（如1920x1080、2560x1440），通过JavaScript screen对象收集，用于界面适配、用户体验优化、响应式设计、图片优化。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（5）设备唯一标识符</strong>：设备的唯一标识（如设备ID），基于设备硬件特征生成，用于防止欺诈、安全验证、设备管理、账户安全、异常检测。采用加密存储、定期更新等安全措施。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>2. 网络信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    主要为您访问服务时的IP地址（IPv4或IPv6地址），用于安全防护、地理位置判断、访问控制、防止恶意攻击、地域服务优化。采用部分脱敏存储（如192.168.1.***），保存30天。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>3. 使用行为信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）访问时间</strong>：您访问和使用服务的时间（精确到秒的时间戳，统一转换为UTC时间存储），用于使用统计、性能分析、安全监控、用户行为分析、服务优化。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）使用功能</strong>：您使用的具体功能模块（文档上传、翻译处理、结果下载等），统计功能使用频率、使用时长，用于功能优化、用户体验改进、产品改进、功能优化。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）操作记录</strong>：您在平台上的操作行为（点击、上传、下载等操作），用于问题诊断、安全审计、服务改进、故障排查、安全分析。保存30天。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（4）页面浏览路径</strong>：您在网站内的浏览轨迹（页面URL、停留时间、跳转路径），采用匿名化统计分析，用于用户体验优化、页面设计改进、网站结构优化、用户体验提升。
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>4. 日志信息</Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（1）服务日志</strong>：系统服务运行日志（ERROR、WARN、INFO、DEBUG等日志级别），用于系统监控、性能优化、故障诊断。保存30天，仅技术运维人员可访问。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（2）错误日志</strong>：系统错误和异常信息（错误类型、发生时间、影响范围），用于问题定位、系统稳定性改进。采用自动告警、及时处理的流程，保存90天。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                    <strong>（3）性能数据</strong>：系统性能指标数据（响应时间、吞吐量、资源使用率），实时监控收集，用于性能监控、容量规划、服务优化、性能优化、容量扩展。
                  </Typography>
                  
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    <strong>（4）安全事件记录</strong>：安全相关事件日志（登录异常、访问异常、攻击尝试），用于安全监控、威胁检测、事件响应。采用自动检测、实时告警、人工处理的机制，保存1年。
                  </Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>1.3 特殊类型信息</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  对于涉及个人敏感信息的文档（如身份证、护照等），我们会：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>采用最高级别的安全措施保护；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>仅用于翻译服务目的；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>在服务完成后按约定时间删除；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不会用于其他任何目的。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>1.4 儿童信息保护</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们不会主动收集18周岁以下未成年人的个人信息。如果您是未成年人的监护人，发现我们收集了您监护的未成年人的个人信息，请及时联系我们，我们会立即删除相关信息。
                </Typography>
              </Box>
            </Box>

            {/* 第二章 我们如何使用个人信息 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第二章 我们如何使用个人信息
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>2.1 使用目的</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  我们会基于以下目的使用您的个人信息：
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（一）提供核心服务</strong>：我们使用您的个人信息来提供PageSmooth的核心翻译服务，包括对您上传的文档进行智能解析和翻译处理，保持原文档的格式和排版，通过AI技术结合人工审核确保翻译质量，最终生成符合您需求的翻译结果文件。这是我们服务的基础功能，需要处理您的文档内容、账户信息和使用偏好等数据。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（二）账户管理</strong>：为了确保您能够安全、便捷地使用我们的服务，我们需要使用您的个人信息进行用户身份验证，包括登录验证、密码重置等安全操作，同时保护您的账户安全，防止未经授权的访问。我们还会管理您的点数余额、消费记录，维护您的翻译历史和使用记录，以便您随时查看和管理自己的服务使用情况。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（三）支付处理</strong>：当您购买我们的付费服务时，我们需要处理您的支付信息来生成订单、验证支付状态，并维护相关的财务记录。我们会与第三方支付服务商合作完成支付流程，确保交易的安全性和准确性，同时为您提供完整的消费记录和发票服务。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（四）客户服务</strong>：为了提供优质的客户服务体验，我们会使用您的联系信息和服务使用情况来响应您的咨询和技术支持请求，处理您的投诉和建议，解决您在使用过程中遇到的问题。我们还会基于您的反馈和使用数据持续改进我们的服务质量，优化产品功能和用户体验。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（五）安全保障</strong>：为了维护平台和用户的安全，我们会使用您的设备信息、网络信息和行为数据来防范各种安全威胁，检测异常登录、恶意攻击等可疑行为，防止欺诈活动和滥用行为，确保系统的稳定运行。我们采用先进的安全技术和风控模型来保护您的账户和数据安全。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  <strong>（六）服务优化</strong>：我们会对用户的使用行为和偏好进行匿名化分析，了解用户需求趋势和使用模式，以此来改进我们的产品功能，优化翻译算法和用户界面，开发新的功能特性。这些分析有助于我们为您提供更加个性化和高效的翻译服务，提升整体的用户体验。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>2.2 使用原则</Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>合法性</strong>：严格遵守相关法律法规；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>正当性</strong>：仅用于合理的业务目的；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>必要性</strong>：限于实现目的所必需的范围；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>透明性</strong>：向您明确说明使用目的。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>2.3 特殊情况说明</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  在以下情况下，我们可能会使用您的信息：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>遵守法律法规要求；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>维护公共安全；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>保护您或他人的合法权益；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>履行与您的协议。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第三章 信息存储与安全 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第三章 信息存储与安全
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>3.1 存储位置</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  您的个人信息主要存储在中华人民共和国境内的服务器上。如需跨境传输，我们会严格遵守相关法律法规，并采取必要的安全措施。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>3.2 存储期限</Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（一）账户信息</strong>：我们会在您的账户存续期间持续保存您的基本账户信息，包括用户名、邮箱、手机号等注册信息，以及您的个人资料和偏好设置。当您主动注销账户时，我们会在7天内彻底删除您的账户信息，但法律法规要求保留的信息除外。在此期间，您仍可以恢复账户，超过7天后账户信息将无法恢复。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（二）翻译文件</strong>：为了保护您的隐私和节约存储资源，我们对翻译文件采用限时存储策略。您上传的原始文件在翻译完成后会在7天内自动删除，翻译生成的结果文件会保存7天供您下载和查看。您可以随时通过平台主动删除自己的文件，删除后文件将立即从我们的服务器中移除且无法恢复。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（三）交易记录</strong>：为了满足财务管理和法律合规要求，我们会保存您的交易记录（包括充值、消费、退款等）3年时间。这些记录用于财务对账、税务申报、争议处理等合法目的。超过保存期限后，相关记录会自动删除，但法律法规要求更长保存期限的除外。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  <strong>（四）日志信息</strong>：我们会保存系统操作日志和安全日志6个月，这些日志主要用于系统安全监控、故障排查和技术分析。日志信息不包含您上传的文件内容，仅记录操作时间、IP地址、操作类型等技术信息。超过保存期限后，日志信息会自动清理删除。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>3.3 安全措施</Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（一）技术安全</strong>：我们采用业界领先的技术手段保护您的个人信息安全。所有存储的个人信息都使用高强度加密算法进行加密保护，确保即使在极端情况下数据也无法被非法获取。我们在全站部署HTTPS加密传输协议，保障您与我们服务器之间的数据传输安全。同时建立了多层身份验证机制，包括密码验证、短信验证码、邮箱验证等，防止未经授权的访问。我们还实施严格的数据隔离策略，确保不同用户的数据完全隔离，互不可见。为防止数据丢失，我们建立了完善的多重备份机制，在多个地理位置保存数据副本。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（二）管理安全</strong>：在管理层面，我们建立了完善的信息安全管理体系。实施严格的员工权限管理制度，采用最小权限原则，员工及专业译员只能访问履行职责所必需的信息，并且所有访问都有详细的日志记录。我们定期对员工及译员进行信息安全意识培训，确保每位员工和译员都了解并遵守信息保护规定。建立了全面的操作审计监控系统，对所有敏感操作进行实时监控和记录。同时制定了完善的安全事件应急响应机制，能够在发生安全事件时快速响应和处理。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  <strong>（三）物理安全</strong>：我们的服务器托管在符合国际标准的专业数据中心，这些数据中心具备完善的物理安全保障措施。数据中心实施24小时环境监控，包括温度、湿度、电力等关键环境参数的实时监测。建立了严格的物理访问控制系统，包括多重身份验证、生物识别、视频监控等措施，确保只有授权人员才能进入服务器区域。数据中心还配备了完善的消防、防盗、防灾等安全设施。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>3.4 安全事件处理</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  如发生个人信息安全事件，我们将：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>立即启动应急预案；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>及时控制事件影响；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>评估风险等级；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>按法律要求及时通知您；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>配合相关部门调查；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>持续改进安全措施。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第四章 信息共享与转让 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第四章 信息共享与转让
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>4.1 共享原则</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们严格遵循最小化原则，不会向第三方出售、出租或以其他方式披露您的个人信息。我们只有在以下情况下才可能共享您的个人信息：获得您的明确同意并在您同意的范围内进行共享；法律法规明确要求我们披露特定信息时，我们会严格按照法律要求的范围和方式进行；为履行与您签订的服务协议或法定义务而必须共享的情况；在法律允许的范围内，为维护您、我们或其他用户的合法权益而必要的共享。在任何情况下，我们都会要求信息接收方承诺按照不低于本隐私政策的标准保护您的个人信息。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>4.2 可能的共享情形</Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（一）服务提供商</strong>：为了向您提供完整的服务体验，我们可能需要与可信赖的第三方服务提供商共享必要的信息。这包括与支付服务商（如支付宝、微信支付、银联等）共享支付相关信息以处理您的支付交易；与云服务提供商共享技术数据以确保服务的稳定性和可靠性。我们会与所有第三方服务提供商签署严格的数据保护协议，要求其严格按照我们的指示和本隐私政策的要求处理您的个人信息，并采取适当的安全措施保护您的信息。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（二）法律要求</strong>：在某些情况下，我们可能需要根据法律法规的要求披露您的个人信息。这包括遵守法院的判决书、裁定书或其他法律文书的要求；配合公安、检察院、法院等执法部门的合法调查；履行法律法规规定的报告、备案等义务；为维护国家安全、公共安全或重大公共利益的需要。在这些情况下，我们会严格按照法律要求的范围和方式进行信息披露，并在法律允许的情况下及时通知您。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  <strong>（三）业务转让</strong>：如果我们发生合并、收购、资产转让或类似的商业交易，您的个人信息可能会作为此类交易的一部分被转移。在这种情况下，我们会提前通知您相关情况，确保信息接收方承诺按照不低于本隐私政策的标准继续保护您的个人信息。如果您不同意信息转移，您有权要求我们删除您的个人信息。我们会确保整个过程符合相关法律法规的要求。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>4.3 匿名化处理</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们可能会对收集的信息进行统计分析和数据挖掘，形成无法识别特定个人身份的匿名化数据。这些匿名化数据主要用于改进我们的服务质量，通过分析用户使用模式和偏好来优化翻译算法和用户界面；进行行业研究分析，了解翻译服务市场的发展趋势和用户需求变化；优化产品功能，基于用户行为数据开发更符合用户需求的新功能。匿名化处理过程中，我们会采用技术手段确保数据无法被逆向识别，保护您的个人隐私。
                </Typography>
              </Box>
            </Box>

            {/* 第五章 您的权利 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第五章 您的权利
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.1 访问权</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  您有权了解我们收集、使用您个人信息的具体情况，这是您的基本权利。您可以要求我们提供以下信息：我们收集了您哪些类型的个人信息，包括基本信息、设备信息、使用行为信息等；我们使用这些信息的具体目的和方式，以及使用的法律依据；这些信息在我们系统中的存储期限和删除计划；我们是否与第三方共享了您的信息，以及共享的范围和目的。我们会在收到您的请求后15个工作日内提供相关信息，帮助您更好地了解和控制自己的个人信息。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.2 更正权</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  如发现我们处理的您的个人信息有错误，您有权要求我们更正。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.3 删除权</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  您有权要求我们删除您的个人信息，这是您对自己信息的重要控制权利。在以下情况下，您可以行使删除权：当我们收集和使用您个人信息的目的已经实现，不再需要继续处理时；当您撤回了对我们处理您个人信息的同意，且我们没有其他合法理由继续处理时；当我们违反法律法规或本隐私政策的规定处理您的个人信息时；当法律法规明确要求删除您的个人信息时。我们会在收到您的删除请求后及时评估，如果符合删除条件，我们会在15个工作日内删除相关信息，并通知可能获得您个人信息的第三方及时删除。但请注意，如果法律法规要求我们保留某些信息，我们可能无法立即删除。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.4 撤回同意权</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  对于基于您同意处理的个人信息，您有权随时撤回同意。撤回同意不影响撤回前的处理合法性。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.5 可携带权</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  您有权获取我们处理的您的个人信息副本，在技术可行的情况下，我们可将信息传输给您指定的第三方。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.6 限制处理权</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  在特定情况下，您有权要求我们限制处理您的个人信息。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>5.7 权利行使方式</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  为了方便您行使上述各项权利，我们提供了多种便捷的联系方式。您可以登录您的账户，在个人中心或隐私设置页面直接进行在线操作，包括查看、修改、删除个人信息等；您也可以发送邮件至我们的专用隐私保护邮箱：privacy@pagesmooth.com，我们的隐私保护专员会及时处理您的请求；您还可以通过平台内置的在线客服系统联系我们，客服人员会协助您处理相关事宜；如有需要，您也可以拨打我们的客服电话进行咨询。我们承诺会在收到您的请求后15个工作日内给予回复，如果情况复杂需要更长时间处理，我们会及时告知您具体的处理时间安排。
                </Typography>
              </Box>
            </Box>

            {/* 第六章 Cookie和类似技术 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第六章 Cookie和类似技术
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>6.1 Cookie使用</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们使用Cookie和类似的网络技术来提升您的使用体验和服务质量。Cookie是网站存储在您设备上的小型文本文件，帮助我们记住您的登录状态，避免您每次访问都需要重新登录；保存您的个人偏好设置，如语言选择、界面布局等，让您获得个性化的服务体验；分析网站的使用情况和用户行为模式，帮助我们了解哪些功能最受欢迎，哪些页面需要改进；持续改善用户体验，通过数据分析优化网站性能和功能设计。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>6.2 Cookie类型</Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（一）必要Cookie</strong>：这类Cookie对于网站的基本功能运行是必不可少的，主要用于维持网站的基本功能正常运行，如页面导航、表单提交、用户认证等核心功能；保障网站和用户的安全性，防止跨站请求伪造（CSRF）攻击和其他安全威胁；维护用户会话状态，确保您在浏览不同页面时保持登录状态。由于这类Cookie对网站功能至关重要，因此无法被禁用，但它们不会收集您的个人身份信息。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                  <strong>（二）功能Cookie</strong>：这类Cookie用于增强网站功能和用户体验，主要功能包括记住您的用户偏好，如语言设置、时区、字体大小等个性化选项；提供个性化服务，根据您的使用习惯推荐相关功能或内容；保存您的操作历史，如最近使用的翻译语言对、常用的文档格式等。这类Cookie可以通过浏览器设置进行禁用，但禁用后可能会影响某些个性化功能的使用。
                </Typography>
                
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  <strong>（三）分析Cookie</strong>：这类Cookie帮助我们了解网站的使用情况和性能表现，主要用于收集网站访问统计信息，如页面浏览量、访问时长、跳出率等；分析用户行为模式，了解用户如何与网站互动，哪些功能最受欢迎；监控网站性能，识别和解决技术问题，提升网站加载速度和稳定性。这类Cookie收集的是匿名化的统计数据，不会识别您的个人身份，您可以选择禁用这类Cookie。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>6.3 管理Cookie</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  您可以通过多种方式管理Cookie设置，以控制我们如何使用这些技术。您可以通过浏览器设置选择接受所有Cookie，这样可以获得完整的网站功能体验；也可以选择拒绝所有Cookie，但这可能会影响网站的正常功能使用；您还可以进行选择性接受，只允许必要的Cookie而禁用功能性和分析性Cookie；您也可以随时删除已存储在您设备上的Cookie。大多数现代浏览器都提供了详细的Cookie管理选项，您可以在浏览器的隐私或安全设置中找到这些选项。
                </Typography>
              </Box>
            </Box>

            {/* 第七章 第三方服务 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第七章 第三方服务
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>7.1 第三方链接</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们的服务可能包含第三方网站链接。这些第三方网站有自己的隐私政策，我们不对其隐私做法承担责任。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>7.2 第三方服务集成</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  为了为您提供更完整和便捷的服务体验，我们可能会集成一些第三方服务来增强平台功能。这些集成服务主要包括支付服务，我们与支付宝、微信支付、银联等知名支付服务商合作，为您提供安全便捷的支付体验；地图服务，用于显示服务覆盖区域或提供地理位置相关的功能；社交媒体分享功能，让您可以方便地将翻译结果分享到微信、微博等社交平台。当您使用这些集成的第三方服务时，请注意这些服务提供商有自己独立的隐私政策和服务条款，我们建议您仔细阅读并了解其隐私保护做法。
                </Typography>
              </Box>
            </Box>

            {/* 第八章 国际传输 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第八章 国际传输
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>8.1 跨境传输原则</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们主要在中华人民共和国境内存储和处理您的个人信息。如果因业务需要必须将您的个人信息传输至境外，我们会严格遵守相关法律法规的要求，确保跨境传输的合法性，包括获得必要的监管批准或备案；采取必要的安全保护措施，确保数据在传输过程中的安全性和完整性；要求境外的信息接收方提供与境内同等水平的个人信息保护标准，并签署相应的数据保护协议。我们会在进行跨境传输前评估目标国家或地区的数据保护法律环境，确保您的个人信息得到充分保护。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>8.2 传输场景</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  可能需要进行跨境传输的场景主要包括：使用境外云服务提供商的技术服务时，可能需要将部分技术数据传输至境外服务器进行处理；提供境外认证翻译服务时，需要将翻译文件传输给境外的认证机构进行官方认证；获得境外技术支持服务时，可能需要共享必要的技术信息以解决技术问题。在所有这些场景中，我们都会采取严格的安全措施，并确保只传输必要的信息。
                </Typography>
              </Box>
            </Box>

            {/* 第九章 隐私政策更新 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第九章 隐私政策更新
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>9.1 更新原则</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们可能会根据实际情况的变化适时更新本隐私政策，更新的原因主要包括：法律法规发生变化，需要调整政策内容以符合新的法律要求；我们的业务功能发生调整，增加新服务或修改现有服务时需要更新相应的隐私条款；安全技术升级，采用新的安全技术或改进现有安全措施时需要更新相关说明；基于用户反馈和体验改进的需要，优化隐私保护措施和用户权利保障。我们承诺任何更新都将以更好地保护您的隐私权益为目标。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>9.2 通知方式</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  当我们对隐私政策进行重大变更时，我们会通过多种方式及时通知您，确保您能够了解变更内容。通知方式包括在网站首页或隐私政策页面发布公告，详细说明变更的内容和原因；向您的注册邮箱发送邮件通知，提醒您查看更新后的政策；通过平台内的站内消息系统向您发送通知；在您下次登录时通过弹窗提醒的方式告知您政策变更情况。我们会确保通知内容清晰明了，帮助您理解变更对您权益的影响。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>9.3 生效时间</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  更新后的隐私政策将在我们发布公告后30天生效，这个缓冲期让您有充分的时间了解变更内容并做出相应的决定。如果您在新政策生效后继续使用我们的服务，即视为您已同意接受更新后的隐私政策。如果您不同意新的政策条款，您可以选择停止使用我们的服务，并可以要求我们删除您的个人信息。
                </Typography>
              </Box>
            </Box>

            {/* 第十章 争议解决 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第十章 争议解决
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>10.1 投诉渠道</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  如果您对我们的隐私保护做法有任何疑问、意见或投诉，我们提供了多种便捷的联系方式供您使用。您可以发送邮件至我们的专用隐私保护邮箱：privacy@pagesmooth.com，我们的隐私保护专员会及时处理您的咨询和投诉；您也可以通过平台内置的在线客服系统联系我们，客服人员会协助您解决隐私相关的问题；我们的客服服务时间为周一至周五上午9:00至下午18:00，在此时间内您可以获得及时的响应和帮助。我们重视每一位用户的反馈，会认真对待每一个隐私相关的咨询和投诉。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>10.2 处理流程</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  我们建立了完善的投诉处理流程，确保您的问题能够得到及时有效的解决。具体流程包括：我们会在收到您的投诉后24小时内确认收到，并向您发送确认回复，告知您我们已经开始处理您的问题；我们会在15个工作日内对您的投诉进行全面调查和处理，包括核实相关情况、分析问题原因、制定解决方案等；处理完成后，我们会及时向您反馈处理结果，详细说明我们采取的措施和解决方案；我们还会持续跟踪问题的解决效果，根据您的反馈进行必要的改进和优化。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>10.3 外部救济</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  如果您对我们的处理结果不满意，您还可以寻求外部救济途径。您可以向相关监管部门举报或投诉，如网信办、工信部等；您也可以通过司法途径维护自己的合法权益；您还可以向消费者权益保护组织寻求帮助。我们尊重您选择任何合法途径维护自己权益的决定，并会积极配合相关调查和处理工作。
                </Typography>
              </Box>
            </Box>

            {/* 联系我们 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                联系我们
              </Typography>
              
              <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
                如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式联系我们：
              </Typography>
              
              <Box component="ul" sx={{ pl: 3, mb: 3 }}>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>公司名称</strong>：郑州译悦翻译有限公司</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>联系邮箱</strong>：privacy@pagesmooth.com</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>客服电话</strong>：400-123-4567</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>服务时间</strong>：周一至周五 9:00-18:00</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>通讯地址</strong>：河南省郑州市金水区</Typography>
              </Box>
              
              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                我们会在收到您的联系后尽快回复，感谢您对PageSmooth的信任和支持！
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default NewPrivacy; 